// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 200px;
  margin-top: 20px;
  margin-left: 10px;
  padding-bottom: 5px;
}

.warn {
  width: 200px;
  margin-left: 10px;
  padding-top: 0px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #e30526;
}

.button {
  margin-left: 20px;
  margin-top: 10px;
  width: 175px;
  text-align: center;
}

.mat-icon {
  margin-bottom: 5px;
}

.label {
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 17px;
}

.table {
  margin: 10px;
}

.table-header {
  font-weight: bold;
  background-color: #f2f2ef;
  color: #3b3b39;
  font-size: 15pt;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 7px;
  padding-top: 5px;
}

.segment {
  font-weight: bold;
  background-color: #7b7b7b;
  color: #ffffff;
  margin-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 3px;
}

.region {
  font-weight: bold;
  margin-top: 3px;
  padding-left: 15px;
  border-bottom: 1px solid black;
  padding-bottom: 4px;
}

.menu-relative {
  display: flex;
  width: 100%;
}

.header-style {
  font-weight: bold;
  font-size: 15px;
  width: 60px !important;
  text-align: left;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.mat-mdc-cell {
  width: 10px;
  word-break: break-all;
  border-right: 1px solid #d7d7d7;
  padding-left: 5px !important;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

.table-div {
  width: 100%;
  padding-bottom: 20px;
  overflow: hidden;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-table-div {
  overflow: auto;
  max-height: 82vh;
}

.check-mark {
  padding-left: 7px;
}

.message {
  background-color: yellow;
  border: 1px solid black;
  padding: 3px;
  margin-bottom: 15px;
  border-radius: 5px;
  font-weight: bold;
}

.center-year-col {
  text-align: center;
  width: 100%;
}

.vrrFooter {
  bottom: 0px;
  position: static;
  width: 100% !important;
  margin: 0px;
  padding: 0px;
}

:host ::ng-deep .p-multiselect-panel {
  width: 200px;
}

:host ::ng-deep .p-select {
  width: 200px;
}

:host ::ng-deep .p-datatable-header {
  background-color: #f2f2ef;
  font-size: 25px;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/reports/vehicle-rollout/vehicle-rollout.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAGF;AACA,w9JAAw9J","sourcesContent":[".select {\n  width: 200px;\n  margin-top: 20px;\n  margin-left: 10px;\n  padding-bottom: 5px;\n}\n\n.warn {\n  width: 200px;\n  margin-left: 10px;\n  padding-top: 0px;\n  margin-bottom: 10px;\n  font-size: 11px;\n  color: #e30526;\n}\n\n.button {\n  margin-left: 20px;\n  margin-top: 10px;\n  width: 175px;\n  text-align: center;\n}\n\n.mat-icon {\n  margin-bottom: 5px;\n}\n\n.label {\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 17px;\n}\n\n.table {\n  margin: 10px;\n}\n\n.table-header {\n  font-weight: bold;\n  background-color: #f2f2ef;\n  color: #3b3b39;\n  font-size: 15pt;\n  text-align: center;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding-bottom: 7px;\n  padding-top: 5px;\n}\n\n.segment {\n  font-weight: bold;\n  background-color: #7b7b7b;\n  color: #ffffff;\n  margin-top: 5px;\n  padding-left: 10px;\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.region {\n  font-weight: bold;\n  margin-top: 3px;\n  padding-left: 15px;\n  border-bottom: 1px solid black;\n  padding-bottom: 4px;\n}\n\n.menu-relative {\n  display: flex;\n  width: 100%;\n}\n\n.header-style {\n  font-weight: bold;\n  font-size: 15px;\n  width: 60px !important;\n  text-align: left;\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.mat-mdc-cell {\n  width: 10px;\n  word-break: break-all;\n  border-right: 1px solid #d7d7d7;\n  padding-left: 5px !important;\n  padding-right: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 13px;\n}\n\ntr.mat-mdc-header-row {\n  height: 20px !important;\n  padding-top: 3px !important;\n}\n\n.table-div {\n  width: 100%;\n  padding-bottom: 20px;\n  overflow: hidden;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-table-div {\n  overflow: auto;\n  max-height: 82vh;\n}\n\n.check-mark {\n  padding-left: 7px;\n}\n\n.message {\n  background-color: yellow;\n  border: 1px solid black;\n  padding: 3px;\n  margin-bottom: 15px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.center-year-col {\n  text-align: center;\n  width: 100%;\n}\n\n.vrrFooter {\n  bottom: 0px;\n  position: static;\n  width: 100% !important;\n  margin: 0px;\n  padding: 0px;\n}\n\n:host ::ng-deep .p-multiselect-panel {\n  width: 200px;\n}\n:host ::ng-deep .p-select {\n  width: 200px;\n}\n:host ::ng-deep .p-datatable-header {\n  background-color: #f2f2ef;\n  font-size: 25px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
